module.exports={
  "name": "mvc-lib",
  "version": "1.0.5",
  "description": "A pure and powerful JavaScript MetaverseChain (mvc) library.",
  "author": "zyoyoung <ouyangzhiying@showpay.top>",
  "ide": true,
  "main": "index.js",
  "scripts": {
    "lint": "standard",
    "test": "standard && mocha",
    "coverage": "nyc --reporter=text npm run test",
    "build-mvc": "webpack index.js --config webpack.config.js",
    "build-ecies": "webpack ecies/index.js --config webpack.subproject.config.js --output-library mvcEcies -o mvc-ecies.min.js",
    "build-message": "webpack message/index.js --config webpack.subproject.config.js --output-library mvcMessage -o mvc-message.min.js",
    "build-mnemonic": "webpack mnemonic/index.js --config webpack.subproject.config.js --output-library mvcMnemonic -o mvc-mnemonic.min.js",
    "build": "yarn build-mvc && yarn build-ecies && yarn build-message && yarn build-mnemonic",
    "prepublishOnly": "yarn build"
  },
  "unpkg": "mvc.min.js",
  "keywords": [
    "mvc",
    "metaversechain",
    "transaction",
    "address",
    "p5p",
    "ecies",
    "cryptocurrency",
    "blockchain",
    "payment",
    "bip21",
    "bip32",
    "bip37",
    "bip69",
    "bip70",
    "multisig"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/MetaverseChain/mvc-lib-js"
  },
  "browser": {
    "request": "browser-request"
  },
  "dependencies": {
    "aes-js": "^3.1.2",
    "bn.js": "=4.11.9",
    "bs58": "=4.0.1",
    "clone-deep": "^4.0.1",
    "elliptic": "6.5.4",
    "hash.js": "^1.1.7",
    "inherits": "2.0.3",
    "unorm": "1.4.1"
  },
  "devDependencies": {
    "brfs": "2.0.1",
    "chai": "4.2.0",
    "mocha": "^8.4.0",
    "nyc": "^14.1.1",
    "sinon": "7.2.3",
    "standard": "12.0.1",
    "webpack": "4.29.3",
    "webpack-cli": "^3.3.12"
  },
  "license": "MIT",
  "standard": {
    "globals": [
      "afterEach",
      "beforeEach",
      "describe",
      "it"
    ],
    "ignore": [
      "dist/**"
    ]
  }
}
